<template>
  <div class="list-header-nav disable-select" @contextmenu.prevent>
    <div class="list-header-nav__box" v-click-outside="onClickOutside" ref="box">

      <div class="list-side-menu__btn" :class="{'show-menu':$store.showSideBar}">
        <a class="menu-btn" style="cursor:pointer;" :class="{'active':$store.showSideBar}" @click="openSidebar"></a>
      </div>

      <!-- ol是面包屑导航，input 是输入框 -->
      <ol class="breadcrumb text-overflow allow-user-select" ref="crumbs" @dblclick="onEditCrumbs"
        v-show="!crumbsEditShow" :style="`width:${crumbWidth}px`">
        <li v-for="(item,index) in crumbs" :key="`crumb-${index}`" :title="item.name">
          <a href="javascript:void(0)" @click="jumpToCrumb(item)">{{item.sampleName}}</a>
        </li>
      </ol>

      <div class="breadcrumb-input-group-wrap" v-show="crumbsEditShow" :style="`width:${crumbWidth}px`">
        <span class="default-text allow-user-select">{{crumbsDefault}}</span>
        <input type="text" class="tc-15-input-text" v-model.trim="crumbsEdit" @keyup.enter="onChangeCrumbs"
          @keyup.esc="onExitEdit">
        <span class="bor"></span>
      </div>

      <div class="path-operate" v-show="!crumbsEditShow && crumbs.length > 1">
        <button class="tc-15-btn weak m mr-5" @click.stop="onCopyPath">{{$t('core.copy')}}</button>
        <!-- <button class="tc-15-btn weak m" @click.stop="onEditCrumbs">{{$t('core.edit')}}</button> -->
      </div>

    </div>
  </div>
</template>

<script>
import $ from 'jquery';
import _ from 'lodash';

import clickOutside from '@/scripts/directives/clickOutside';
import { copyText2Clipboard } from '@/scripts/tools/utils';
import eventProxy from '@/scripts/tools/eventProxy';

export default {
  directives: {
    clickOutside,
  },
  data() {
    return {
      crumbWidth: 300,
      renderCrumbs: [],
      crumbsEditShow: false,
      crumbsEdit: '',
      crumbsOperateShow: false,

      clickTag: 'null',
    };
  },
  computed: {
    crumbsDefault() {
      let crumbsDefaultEdit = '';
      this.crumbs.forEach((item, index) => {
        if (index < 2) {
          crumbsDefaultEdit += `${item.name}/`;
        }
      });
      return crumbsDefaultEdit;
    },
    crumbs: {
      get() {
        const { crumbs } = this.$store;
        const len = crumbs.length;
        crumbs.forEach((item, index) => {
          // 面包屑导航超过 5 个则第三个开始显示 ...
          if (len > 4 && index > 1 && index < len - 2) {
            item.sampleName = '...';
          } else {
            item.sampleName = item.name;
          }
          item.index = index;
        });
        return crumbs;
      },
      set(val) {
        this.$store.crumbs = val;
      },
    },
    // 深拷贝当前路径，否则无法监控到路径变化
    currPath() {
      return _.cloneDeep(this.$store.crumbs);
    },
  },
  watch: {
    // 根据路由来改变面包屑导航
    $route() {
      this.handleRoute();
    },
  },
  mounted() {
    this.renderCrumbWidth();
    this.handleRoute();
    eventProxy.on('winResize', this.renderCrumbWidth);
  },
  beforeDestroy() {
    eventProxy.off('winResize', this.renderCrumbWidth);
  },
  methods: {
    handleRoute() {
      if (this.$route.name === 'bucket') {
        this.$mutations.initCrumbs();
        return;
      }
      const { bucket, region, path } = this.$route.query;
      this.$mutations.computeCrumbs({ bucket, region, path });
    },
    // 渲染路径导航宽度
    renderCrumbWidth() {
      const wholeWidth = this.$refs.box.clientWidth;
      const { children } = this.$refs.box;
      const operateBtnDom = children[1];
      if (operateBtnDom) {
        const operateBtn = $(operateBtnDom);
        const btnLeft = operateBtn.offset().left;
        const btnWidth = operateBtn.width();
        const MARGIN_R = 20;
        this.crumbWidth = wholeWidth - btnLeft - btnWidth - MARGIN_R - 20; // 给导航20像素空余
      }
    },
    openSidebar() {
      this.$store.showSideBar = !this.$store.showSideBar;
      this.$nextTick(() => {
        if (this.$store.showSideBar) {
          this.crumbWidth -= 115;
        } else {
          // 延迟 300ms 原因：必须等待侧边栏完全关闭才将宽度还原，否则导航突变会导致长度容纳不下
          setTimeout(() => {
            this.crumbWidth += 115;
          }, 300);
        }
      });
    },
    jumpToCrumb(item) {
      const { index } = item;
      const { crumbs } = this;
      crumbs.splice(index + 1, crumbs.length - index + 1);
      if (crumbs.length === 1) {
        this.$router.push({ name: 'bucket' }).catch(() => {});
        return;
      }

      const { name: bucket, region } = crumbs[1];
      const path = this.$store.crumbs.reduce((res, crumb, i) => {
        if (i > 1) {
          res += `${crumb.name}/`;
        }
        return res;
      }, '');

      const query = { bucket, region, path };
      if (!query.path) delete query.path;
      this.$router.push({ name: 'file', query }).catch(() => {});
    },
    onEditCrumbs() {
      if (this.renderCrumbs.length > 1) {
        this.getInitCrumbsEdit();
        this.crumbsEditShow = true;
      }
    },
    onCopyPath() {
      this.getInitCrumbsEdit();
      const path = this.crumbsDefault + this.crumbsEdit;
      copyText2Clipboard(path, 'copy_path');
    },
    onExitEdit() {
      this.crumbsEditShow = false;
    },
    onClickOutside() {
      this.crumbsEditShow = false;
      this.crumbsEdit = '';
    },
    onChangeCrumbs() {
      this.crumbsEditShow = false;
      let len = this.crumbs.length;
      while (len > 2) {
        this.crumbs.pop();
        len--;
      }
      const prefix = (this.crumbsEdit || '')
        .replace(/^\//, '')
        .replace(/\/$/, '');
      let prefixKey = '';
      if (prefix) {
        prefix.split('/').forEach(name => {
          if (name) {
            prefixKey += `${name}/`;
            this.crumbs.push({ name, prefix: prefixKey });
          }
        });
      }
      this.crumbsEdit = '';
    },
    getInitCrumbsEdit() {
      this.crumbsEdit = '';
      this.crumbs.forEach((item, index) => {
        if (index > 1) {
          this.crumbsEdit += `${item.name}/`;
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
.list-header-nav__box {
  position: relative;
  .path-operate {
    display: none;
    position: absolute;
    right: 0;
    top: 0;
    button {
      padding: 0 6px;
      height: 28px;
      line-height: 28px;
    }
  }
  &:hover .path-operate {
    display: block;
  }
}

.text-overflow {
  /* width: 100%; */
  cursor: pointer;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.pd-0 {
  padding: 0;
}
</style>
